export default __webpack_public_path__ + "static/media/P1090073.6d990ab3.6d990ab3.JPG";